import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import {
  SetFilterByCompanyType,
  SetFilterByMemberPriority,
  SetFilterByRetailPriority,
  MonitorActionTypes
} from './actions';

@Injectable()
export class MonitorEffects {
  @Effect()
  public readonly selectTab: Observable<Action> = this.actions.pipe(
    ofType(MonitorActionTypes.SetViewType),
    switchMap(() =>
      of(
        new SetFilterByCompanyType(),
        new SetFilterByMemberPriority(),
        new SetFilterByRetailPriority()
      )
    )
  );

  constructor(private actions: Actions) {}
}
